module.exports = __webpack_public_path__ + "assets/img/2_762.f2538367.jpg";